export { version } from './src/package.js'
import { dropdown } from './src/dropdown.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    dropdown: dropdown
  })
}
